//
//
//
//
//
//
//
//
//
//
//
//
//

import CdnService from './cdn_config'
export default {
    data() {
        return {
            stickers: [],
            height: 0
        }
    },
    props: {
        show_stickers: Boolean
    },
    watch: {
        show_stickers (latest) {
            if (latest) {
                this.height = 300
            } else {
                this.height = 0
            }
        }
    },
    async mounted() {
        const { gft_stickers } = await CdnService.getChatConfig()
        this.stickers = gft_stickers
    },
    methods: {
        getImgPath (name, type) {
            return 'https://cdn.vip-wifi.com/fangchan/config/pages/chat_list/gft_stickers/' + name + '.' + type
        },
        chooseSticker(path, name) {
            this.$sendCtmEvtLog(`微聊-发送表情包-${name}`)
            this.$emit('chooseSticker', path, name)
        },
    }
}
